function reorderJudgeMeBadges() {
    document.querySelectorAll('.jdgm-prev-badge').forEach(badge => {
        if (badge.querySelector('.custom-average-rating')) return;

        const rating = badge.getAttribute('data-average-rating');
        const stars = badge.querySelector('.jdgm-prev-badge__stars');

        if (!rating || !stars) return;

        const average = document.createElement('span');
        average.className = 'custom-average-rating';
        average.textContent = Number(rating).toFixed(1);

        stars.before(average);
    });
}

document.addEventListener('DOMContentLoaded', () => {
    reorderJudgeMeBadges();
});